var React = require('react');

function CategoryGeneral (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.4,0H1.6C0.7,0,0,0.7,0,1.6L0,16l3.2-3.2h11.2c0.9,0,1.6-0.7,1.6-1.6V1.6C16,0.7,15.3,0,14.4,0z M3.2,5.6h9.6v1.6H3.2\n\tV5.6z M9.6,9.6H3.2V8h6.4V9.6z M12.8,4.8H3.2V3.2h9.6V4.8z","fill":"currentColor"}));
}

CategoryGeneral.defaultProps = {"version":"1.1","id":"general","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = CategoryGeneral;

CategoryGeneral.default = CategoryGeneral;
